import {
  formatDateOrDash,
  formatDateTimeOrDash,
} from '#/utils/date';

import { formatAdjustmentSourceTypeLabel } from './adjustmentSourceType';

export function mapStockAdjustmentMeta(detail) {
  return {
    code: detail?.adjustmentNo || '-',
    status: detail?.status || '',
    adjustmentDate: formatDateOrDash(detail?.adjustmentDate),
    sourceTypeLabel: formatAdjustmentSourceTypeLabel(detail?.sourceType),
    issueReason: detail?.issueReason || '',
    remark: detail?.remark || '',
    createDate: formatDateTimeOrDash(detail?.record?.createdAt),
    reviseDate: formatDateTimeOrDash(detail?.record?.updatedAt),
    closeDate: formatDateTimeOrDash(detail?.history?.completedAt),
    lineCount: detail?.lines?.length ?? detail?.lineCount ?? 0,
  };
}
